<template>
  <ul class="pagination" :class="paginationClass">
    <li class="page-item prev-page" :class="{disabled: modelValue === 1}">
      <a class="page-link" aria-label="Previous" @click="firstPage">
        <span aria-hidden="true"><i class="fa fa-angle-double-left" aria-hidden="true"/></span>
      </a>
    </li>
    <el-popover
      v-for="item in range(minPage, maxPage)"
      :key="item"
      placement="top"
      width="100"
      trigger="hover"
      :disabled="modelValue !== item"
      popper-class="pagination-input">
      <fg-input
        v-model="inputValue"
        :label="`1-${pageCount}`"
        @pressEnter="inputValue && parseInt(inputValue) ? $emit('update:model-value', parseInt(inputValue)) : undefined"/>
      <template #reference>
        <li class="page-item" :class="{active: modelValue === item}">
          <a class="page-link" @click="changePage(item)">{{ item }}</a>
        </li>
      </template>
    </el-popover>
    <li class="page-item next-page" :class="{disabled: modelValue === totalPages}">
      <a class="page-link" aria-label="Next" @click="lastPage">
        <span aria-hidden="true"><i class="fa fa-angle-double-right" aria-hidden="true"/></span>
      </a>
    </li>
  </ul>
</template>
<script>
import { ElPopover } from 'element-plus'

export default {
  name: 'PPagination',
  components: {
    ElPopover
  },
  props: {
    type: {
      type: String,
      default: 'default',
      description: 'Pagination type (primary|info|danger|default|warning|success)'
    },
    pageCount: {
      type: Number,
      default: 0,
      description: 'Pagination page count. This should be specified in combination with perPage'
    },
    perPage: {
      type: Number,
      default: 10,
      description: 'Pagination per page. Should be specified with total or pageCount'
    },
    total: {
      type: Number,
      default: 0,
      description: 'Can be specified instead of pageCount. The page count in this case will be total/perPage'
    },
    modelValue: {
      type: Number,
      default: 1,
      description: 'Pagination value'
    }
  },
  data() {
    return {
      defaultPagesToDisplay: 3,
      showPageInput: false,
      inputValue: '1'
    }
  },
  computed: {
    paginationClass() {
      return `pagination-${this.type}`
    },
    totalPages() {
      if (this.pageCount > 0) return this.pageCount
      if (this.total > 0) {
        return Math.ceil(this.total / this.perPage)
      }
      return 1
    },
    pagesToDisplay() {
      if (this.totalPages > 0 && this.totalPages < this.defaultPagesToDisplay) {
        return this.totalPages
      }
      return this.defaultPagesToDisplay
    },
    minPage() {
      if (this.modelValue >= this.pagesToDisplay) {
        const pagesToAdd = Math.floor(this.pagesToDisplay / 2)
        const newMaxPage = pagesToAdd + this.modelValue
        if (newMaxPage > this.totalPages) {
          return this.totalPages - this.pagesToDisplay + 1
        }
        return this.modelValue - pagesToAdd
      } else {
        return 1
      }
    },
    maxPage() {
      if (this.modelValue >= this.pagesToDisplay) {
        const pagesToAdd = Math.floor(this.pagesToDisplay / 2)
        const newMaxPage = pagesToAdd + this.modelValue
        if (newMaxPage < this.totalPages) {
          return newMaxPage
        } else {
          return this.totalPages
        }
      } else {
        return this.pagesToDisplay
      }
    }
  },
  watch: {
    perPage() {
      this.$emit('update:model-value', 1)
    },
    total() {
      this.$emit('update:model-value', 1)
    },
    modelValue(v) {
      this.inputValue = `${v}`
    },
    inputValue(newValue, oldValue) {
      if (!newValue.match(/^\d*$/)) {
        this.inputValue = oldValue || '1'
        return
      }
      if (newValue && parseInt(newValue)) {
        this.inputValue = `${Math.min(newValue, this.pageCount)}`
      }
    }
  },
  methods: {
    range(min, max) {
      let arr = []
      for (let i = min; i <= max; i++) {
        arr.push(i)
      }
      return arr
    },
    changePage(item) {
      this.$emit('update:model-value', item)
    },
    nextPage() {
      if (this.modelValue < this.totalPages) {
        this.$emit('update:model-value', this.modelValue + 1)
      }
    },
    prevPage() {
      if (this.modelValue > 1) {
        this.$emit('update:model-value', this.modelValue - 1)
      }
    },
    firstPage() {
      this.$emit('update:model-value', 1)
    },
    lastPage() {
      this.$emit('update:model-value', this.totalPages)
    }
  }
}
</script>
